"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _pako = _interopRequireDefault(require("pako"));
var _core = _interopRequireDefault(require("./core"));
var _logger = _interopRequireDefault(require("../logger"));
var _uuid = require("uuid");
var _bops = _interopRequireDefault(require("bops"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Fetcher = exports["default"] = /*#__PURE__*/function (_Core) {
  function Fetcher(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Fetcher);
    _this = _callSuper(this, Fetcher, [props]);
    _this.connection = props.connection;
    _this.appName = props.appName;
    _this.on = _this.on.bind(_this);
    _this._events = {};
    _this.ready = false;
    _this.init();
    _this.myServices = ["fetcher"];
    return _this;
  }
  (0, _inherits2["default"])(Fetcher, _Core);
  return (0, _createClass2["default"])(Fetcher, [{
    key: "handleMessage",
    value: function () {
      var _handleMessage = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(message) {
        var notification, data, _data;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(message.origin === 'sdk-' + this.appName)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.t0 = message.action;
              _context.next = _context.t0 === 'System.SDK.ServiceNotification.Response' ? 5 : _context.t0 === 'System.ServiceNotification' ? 11 : 21;
              break;
            case 5:
              if (!(this.myServices.indexOf(message.origin) === -1)) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return");
            case 7:
              // Store this service into this.services
              this.services[message.origin] = JSON.parse(message.data);
              _logger["default"].success("ServiceNotification", "New service added", message.origin);
              if (!this.ready) {
                this.ready = true;
                this.trigger("ready", true);
              }
              return _context.abrupt("return");
            case 11:
              if (!(this.myServices.indexOf(message.origin) === -1)) {
                _context.next = 13;
                break;
              }
              return _context.abrupt("return");
            case 13:
              // Send our data
              _data = JSON.parse(message.data);
              _context.next = 16;
              return this.connection.invoke('messaging', {
                uuid: (0, _uuid.v4)(),
                action: "".concat(_data.serviceIdentification, ".ServiceNotification.Response"),
                requestUuid: "",
                origin: "sdk-" + this.appName,
                data: JSON.stringify({
                  serviceIdentification: "System.SDK",
                  serviceAbbreviation: "sdk-" + this.appName,
                  publicKey: this.publicKey
                })
              });
            case 16:
              // Store this service into this.services
              this.services[message.origin] = JSON.parse(message.data);
              _logger["default"].success("ServiceNotification", "New service added", message.origin);
              this.ready = true;
              this.trigger("ready", true);
              return _context.abrupt("return");
            case 21:
              return _context.abrupt("break", 22);
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleMessage(_x) {
        return _handleMessage.apply(this, arguments);
      }
      return handleMessage;
    }()
  }, {
    key: "detectServices",
    value: function detectServices() {
      var _this2 = this;
      var found = false;
      Object.keys(this.services).forEach(function (key) {
        if (_this2.myServices.includes(key)) {
          found = true;
        }
      });
      return found;
    }
  }, {
    key: "fetchContent",
    value: function () {
      var _fetchContent = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(uuid, manifest) {
        var _this3 = this;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", new Promise(/*#__PURE__*/function () {
                var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(resolve, reject) {
                  var compressedManifest, base64CompressedManifest, segmentSize, totalChunks, i, segment, payload;
                  return _regenerator["default"].wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        // note the added 'async'
                        //compress manifest
                        compressedManifest = _pako["default"].gzip(JSON.stringify(manifest), {
                          to: 'string'
                        }); //base64 encode compressed manifest
                        base64CompressedManifest = _bops["default"].to(compressedManifest, 'base64');
                        segmentSize = 30720;
                        totalChunks = Math.ceil(base64CompressedManifest.length / segmentSize);
                        i = 0;
                      case 5:
                        if (!(i < totalChunks)) {
                          _context2.next = 13;
                          break;
                        }
                        segment = base64CompressedManifest.substring(i * segmentSize, (i + 1) * segmentSize); // note the added (i + 1)
                        //send each segment 
                        payload = {
                          action: "Systems.AssetsManager.FetchContent",
                          uuid: (0, _uuid.v4)(),
                          requestUuid: "",
                          origin: "sdk-" + _this3.appName,
                          data: JSON.stringify({
                            compressed: true,
                            uuid: uuid,
                            chunk_size: totalChunks,
                            current_chunk: i,
                            manifest: segment
                          })
                        };
                        _context2.next = 10;
                        return _this3.connection.invoke("messaging", payload);
                      case 10:
                        i++;
                        _context2.next = 5;
                        break;
                      case 13:
                        _this3.connection.on("messaging", function (msg) {
                          if (msg.action === "Systems.AssetsManager.FetchContent.Response") {
                            resolve(JSON.parse(msg.data));
                            _logger["default"].success("Content", "Content fetched", "Fetcher");
                          } else if (msg.action === "System.AssetsManager.ContentStatus") {
                            var notification = JSON.parse(msg.data);
                            _this3.trigger("contentStatus", notification);
                          }
                        });
                      case 14:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x4, _x5) {
                  return _ref.apply(this, arguments);
                };
              }()));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function fetchContent(_x2, _x3) {
        return _fetchContent.apply(this, arguments);
      }
      return fetchContent;
    }()
  }, {
    key: "stopDownload",
    value: function stopDownload(uuid) {
      var _this4 = this;
      return new Promise(function (resolve, reject) {
        var payload = {
          action: "Systems.AssetsManager.StopDownload",
          requestUuid: "",
          uuid: (0, _uuid.v4)(),
          origin: "sdk-" + _this4.appName,
          data: ""
        };
        payload.data = JSON.stringify({
          uuid: uuid
        });
        _this4.connection.invoke("messaging", payload).then(function () {
          _this4.connection.on("messaging", function (msg) {
            if (msg.action === "Systems.AssetsManager.StopDownload.Response") {
              resolve(JSON.parse(msg.data));
              _logger["default"].success("Content", "Content stopped", "Fetcher");
            }
          });
        });
      });
    }
  }, {
    key: "init",
    value: function init() {
      _logger["default"].info("Initialization", "Module initialization started, detecting services", "Fetcher");
      var foundServices = this.detectServices();
      if (!foundServices) {
        _logger["default"].warn("Initialization", "No services found. In most cases, this is okay, services will show up soon.", "Fetcher");
      } else {
        this.ready = true;
        this.trigger("ready", true);
        this.connection.on("messaging", this.handleMessage.bind(this));
        _logger["default"].info("Ready", "module initialization ready", "Fetcher");
      }
      this.connection.on("messaging", this.handleMessage.bind(this));
    }
  }]);
}(_core["default"]);